import { PORTFOLIO_NAME, PortfolioName } from './portfolio-list-data';

type Size = {
	width: number;
	height: number;
};

type Color = {
	hex: string;
	textColor: 'white' | '#111111';
};

export type PortfolioDetailData = {
	banner: {
		backgroundImage: string; // 배경 이미지. webp 변환할것.
		logoImage: string; // webp X2으로 추출. webp 변환. pc 기준.
		logoSize: {
			pc: Size;
			tablet: Size;
			mobile: Size;
		};
		shaderOpacity?: number; // optional 배너 이미지 위 반투명 검정 세이더 투명도 (기본:0.3)
	};
	mockup?: {
		// 목업이 없는 경우 렌더링 하지 않음
		mockupImage: string; // 목업 이미지
		mockupVideo: string; // 목업 비디오
	};
	projectInfo: {
		title: string; // 프로젝트 이름
		description: string; // 프로젝트 설명
		clientName: string; // 클라이언트 이름
		duration: string; // 프로젝트 기간
		scope: string; // 프로젝트 범위
	};
	font: PortfolioFont;
	color: {
		point: Color;
		sub1: Color;
		sub2: Color;
		sub3: Color;
		sub4: Color;
	};
	contentImages: {
		// 본문 이미지 배열.
		pc: string[];
		tablet: string[];
		mobile: string[];
	};
};

// 폰트
import { PORTFOLIO_FONT, PortfolioFont } from './portfolio-font-data';

// ----파라다이스 부산----
import ParadiseBusanBanner from './images/detail/paradise-busan/banner-bg.webp';
import ParadiseBusanLogo from './images/detail/paradise-busan/banner-logo.webp';

import ParadiseBusanMockup from '@/assets/images/phone-backgrounds/thumb-paradise-busan.webp';
import ParadiseBusanVideo from '@/assets/videos/phone-videos/phone-paradise-busan.mp4';

import ParadiseBusanPc01 from './images/detail/paradise-busan/pc/01.webp';
import ParadiseBusanPc02 from './images/detail/paradise-busan/pc/02.webp';
import ParadiseBusanPc03 from './images/detail/paradise-busan/pc/03.webp';
import ParadiseBusanPc04 from './images/detail/paradise-busan/pc/04.webp';
import ParadiseBusanPc05 from './images/detail/paradise-busan/pc/05.webp';

import ParadiseBusanTablet01 from './images/detail/paradise-busan/tablet/01.webp';
import ParadiseBusanTablet02 from './images/detail/paradise-busan/tablet/02.webp';
import ParadiseBusanTablet03 from './images/detail/paradise-busan/tablet/03.webp';
import ParadiseBusanTablet04 from './images/detail/paradise-busan/tablet/04.webp';
import ParadiseBusanTablet05 from './images/detail/paradise-busan/tablet/05.webp';

import ParadiseBusanMobile01 from './images/detail/paradise-busan/mobile/01.webp';
import ParadiseBusanMobile02 from './images/detail/paradise-busan/mobile/02.webp';
import ParadiseBusanMobile03 from './images/detail/paradise-busan/mobile/03.webp';
import ParadiseBusanMobile04 from './images/detail/paradise-busan/mobile/04.webp';
import ParadiseBusanMobile05 from './images/detail/paradise-busan/mobile/05.webp';

// ----파라다이스 인천----
import ParadiseIncheonBanner from './images/detail/paradise-incheon/banner-bg.webp';
import ParadiseIncheonLogo from './images/detail/paradise-incheon/banner-logo.webp';

import ParadiseIncheonMockup from '@/assets/images/phone-backgrounds/thumb-paradise-incheon.webp';
import ParadiseIncheonVideo from '@/assets/videos/phone-videos/phone-paradise-incheon.mp4';

// pc만 4개 나머지는 3개임.
import ParadiseIncheonPc01 from './images/detail/paradise-incheon/pc/01.webp';
import ParadiseIncheonPc02 from './images/detail/paradise-incheon/pc/02.webp';
import ParadiseIncheonPc03 from './images/detail/paradise-incheon/pc/03.webp';
import ParadiseIncheonPc04 from './images/detail/paradise-incheon/pc/04.webp';

import ParadiseIncheonTablet01 from './images/detail/paradise-incheon/tablet/01.webp';
import ParadiseIncheonTablet02 from './images/detail/paradise-incheon/tablet/02.webp';
import ParadiseIncheonTablet03 from './images/detail/paradise-incheon/tablet/03.webp';

import ParadiseIncheonMobile01 from './images/detail/paradise-incheon/mobile/01.webp';
import ParadiseIncheonMobile02 from './images/detail/paradise-incheon/mobile/02.webp';
import ParadiseIncheonMobile03 from './images/detail/paradise-incheon/mobile/03.webp';

// ---똑똑365----
import 똑똑365Banner from './images/detail/ttokttok365/banner-bg.webp';
import 똑똑365Logo from './images/detail/ttokttok365/banner-logo.webp';

import 똑똑365Mockup from '@/assets/images/phone-backgrounds/thumb-ttokttok365.webp';
import 똑똑365Video from '@/assets/videos/phone-videos/phone-ttokttok365.mp4';

// pc만 6개 나머지는 5개임.
import 똑똑365Pc01 from './images/detail/ttokttok365/pc/01.webp';
import 똑똑365Pc02 from './images/detail/ttokttok365/pc/02.webp';
import 똑똑365Pc03 from './images/detail/ttokttok365/pc/03.webp';
import 똑똑365Pc04 from './images/detail/ttokttok365/pc/04.webp';
import 똑똑365Pc05 from './images/detail/ttokttok365/pc/05.webp';
import 똑똑365Pc06 from './images/detail/ttokttok365/pc/06.webp';

import 똑똑365Tablet01 from './images/detail/ttokttok365/tablet/01.webp';
import 똑똑365Tablet02 from './images/detail/ttokttok365/tablet/02.webp';
import 똑똑365Tablet03 from './images/detail/ttokttok365/tablet/03.webp';
import 똑똑365Tablet04 from './images/detail/ttokttok365/tablet/04.webp';
import 똑똑365Tablet05 from './images/detail/ttokttok365/tablet/05.webp';

import 똑똑365Mobile01 from './images/detail/ttokttok365/mobile/01.webp';
import 똑똑365Mobile02 from './images/detail/ttokttok365/mobile/02.webp';
import 똑똑365Mobile03 from './images/detail/ttokttok365/mobile/03.webp';
import 똑똑365Mobile04 from './images/detail/ttokttok365/mobile/04.webp';
import 똑똑365Mobile05 from './images/detail/ttokttok365/mobile/05.webp';

// ----디어먼데이----
import DearMondayBanner from './images/detail/dear-monday/banner-bg.webp';
import DearMondayLogo from './images/detail/dear-monday/banner-logo.webp';

import DearMondayMockup from '@/assets/images/phone-backgrounds/thumb-dear-monday.webp';
import DearMondayVideo from '@/assets/videos/phone-videos/phone-dear-monday.mp4';

import DearMondayPc01 from './images/detail/dear-monday/pc/01.webp';
import DearMondayPc02 from './images/detail/dear-monday/pc/02.webp';
import DearMondayPc03 from './images/detail/dear-monday/pc/03.webp';
import DearMondayPc04 from './images/detail/dear-monday/pc/04.webp';
import DearMondayPc05 from './images/detail/dear-monday/pc/05.webp';
import DearMondayPc06 from './images/detail/dear-monday/pc/06.webp';

import DearMondayTablet01 from './images/detail/dear-monday/tablet/01.webp';
import DearMondayTablet02 from './images/detail/dear-monday/tablet/02.webp';
import DearMondayTablet03 from './images/detail/dear-monday/tablet/03.webp';
import DearMondayTablet04 from './images/detail/dear-monday/tablet/04.webp';
import DearMondayTablet05 from './images/detail/dear-monday/tablet/05.webp';
import DearMondayTablet06 from './images/detail/dear-monday/tablet/06.webp';

import DearMondayMobile01 from './images/detail/dear-monday/mobile/01.webp';
import DearMondayMobile02 from './images/detail/dear-monday/mobile/02.webp';
import DearMondayMobile03 from './images/detail/dear-monday/mobile/03.webp';
import DearMondayMobile04 from './images/detail/dear-monday/mobile/04.webp';
import DearMondayMobile05 from './images/detail/dear-monday/mobile/05.webp';
import DearMondayMobile06 from './images/detail/dear-monday/mobile/06.webp';

// ----현대 HMG----
import HyundaiBanner from './images/detail/hyundai/banner-bg.webp';
import HyundaiLogo from './images/detail/hyundai/banner-logo.webp';

import HyundaiMockup from '@/assets/images/phone-backgrounds/thumb-hyundai.webp';
import HyundaiVideo from '@/assets/videos/phone-videos/phone-hyundai.mp4';

import HyundaiPc01 from './images/detail/hyundai/pc/01.webp';
import HyundaiPc02 from './images/detail/hyundai/pc/02.webp';
import HyundaiPc03 from './images/detail/hyundai/pc/03.webp';
import HyundaiPc04 from './images/detail/hyundai/pc/04.webp';
import HyundaiPc05 from './images/detail/hyundai/pc/05.webp';
import HyundaiPc06 from './images/detail/hyundai/pc/06.webp';

import HyundaiTablet01 from './images/detail/hyundai/tablet/01.webp';
import HyundaiTablet02 from './images/detail/hyundai/tablet/02.webp';
import HyundaiTablet03 from './images/detail/hyundai/tablet/03.webp';
import HyundaiTablet04 from './images/detail/hyundai/tablet/04.webp';
import HyundaiTablet05 from './images/detail/hyundai/tablet/05.webp';
import HyundaiTablet06 from './images/detail/hyundai/tablet/06.webp';

import HyundaiMobile01 from './images/detail/hyundai/mobile/01.webp';
import HyundaiMobile02 from './images/detail/hyundai/mobile/02.webp';
import HyundaiMobile03 from './images/detail/hyundai/mobile/03.webp';
import HyundaiMobile04 from './images/detail/hyundai/mobile/04.webp';
import HyundaiMobile05 from './images/detail/hyundai/mobile/05.webp';
import HyundaiMobile06 from './images/detail/hyundai/mobile/06.webp';

// ----vroong----
import VroongBanner from './images/detail/vroong/banner-bg.webp';
import VroongLogo from './images/detail/vroong/banner-logo.webp';

import VroongMockup from '@/assets/images/phone-backgrounds/thumb-vroong.webp';
import VroongVideo from '@/assets/videos/phone-videos/phone-vroong.mp4';

import VroongPc01 from './images/detail/vroong/pc/01.webp';
import VroongPc02 from './images/detail/vroong/pc/02.webp';
import VroongPc03 from './images/detail/vroong/pc/03.webp';
import VroongPc04 from './images/detail/vroong/pc/04.webp';
import VroongPc05 from './images/detail/vroong/pc/05.webp';
import VroongPc06 from './images/detail/vroong/pc/06.webp';

import VroongTablet01 from './images/detail/vroong/tablet/01.webp';
import VroongTablet02 from './images/detail/vroong/tablet/02.webp';
import VroongTablet03 from './images/detail/vroong/tablet/03.webp';
import VroongTablet04 from './images/detail/vroong/tablet/04.webp';
import VroongTablet05 from './images/detail/vroong/tablet/05.webp';
import VroongTablet06 from './images/detail/vroong/tablet/06.webp';

import VroongMobile01 from './images/detail/vroong/mobile/01.webp';
import VroongMobile02 from './images/detail/vroong/mobile/02.webp';
import VroongMobile03 from './images/detail/vroong/mobile/03.webp';
import VroongMobile04 from './images/detail/vroong/mobile/04.webp';
import VroongMobile05 from './images/detail/vroong/mobile/05.webp';
import VroongMobile06 from './images/detail/vroong/mobile/06.webp';

// ----artiket----
import ArtiketBanner from './images/detail/artiket/banner-bg.webp';
import ArtiketLogo from './images/detail/artiket/banner-logo.webp';

import ArtiketMockup from '@/assets/images/phone-backgrounds/thumb-artiket.webp';
import ArtiketVideo from '@/assets/videos/phone-videos/phone-artiket.mp4';

import ArtiketPc01 from './images/detail/artiket/pc/01.webp';
import ArtiketPc02 from './images/detail/artiket/pc/02.webp';
import ArtiketPc03 from './images/detail/artiket/pc/03.webp';
import ArtiketPc04 from './images/detail/artiket/pc/04.webp';
import ArtiketPc05 from './images/detail/artiket/pc/05.webp';
import ArtiketPc06 from './images/detail/artiket/pc/06.webp';

import ArtiketTablet01 from './images/detail/artiket/tablet/01.webp';
import ArtiketTablet02 from './images/detail/artiket/tablet/02.webp';
import ArtiketTablet03 from './images/detail/artiket/tablet/03.webp';
import ArtiketTablet04 from './images/detail/artiket/tablet/04.webp';
import ArtiketTablet05 from './images/detail/artiket/tablet/05.webp';
import ArtiketTablet06 from './images/detail/artiket/tablet/06.webp';

import ArtiketMobile01 from './images/detail/artiket/mobile/01.webp';
import ArtiketMobile02 from './images/detail/artiket/mobile/02.webp';
import ArtiketMobile03 from './images/detail/artiket/mobile/03.webp';
import ArtiketMobile04 from './images/detail/artiket/mobile/04.webp';
import ArtiketMobile05 from './images/detail/artiket/mobile/05.webp';
import ArtiketMobile06 from './images/detail/artiket/mobile/06.webp';

// ----atrasan----
import AtrasanBanner from './images/detail/atrasan/banner-bg.webp';
import AtrasanLogo from './images/detail/atrasan/banner-logo.webp';

import AtrasanMockup from '@/assets/images/phone-backgrounds/thumb-atrasan.webp';
import AtrasanVideo from '@/assets/videos/phone-videos/phone-atrasan.mp4';

import AtrasanPc01 from './images/detail/atrasan/pc/01.webp';
import AtrasanPc02 from './images/detail/atrasan/pc/02.webp';
import AtrasanPc03 from './images/detail/atrasan/pc/03.webp';
import AtrasanPc04 from './images/detail/atrasan/pc/04.webp';
import AtrasanPc05 from './images/detail/atrasan/pc/05.webp';

import AtrasanTablet01 from './images/detail/atrasan/tablet/01.webp';
import AtrasanTablet02 from './images/detail/atrasan/tablet/02.webp';
import AtrasanTablet03 from './images/detail/atrasan/tablet/03.webp';
import AtrasanTablet04 from './images/detail/atrasan/tablet/04.webp';
import AtrasanTablet05 from './images/detail/atrasan/tablet/05.webp';

import AtrasanMobile01 from './images/detail/atrasan/mobile/01.webp';
import AtrasanMobile02 from './images/detail/atrasan/mobile/02.webp';
import AtrasanMobile03 from './images/detail/atrasan/mobile/03.webp';
import AtrasanMobile04 from './images/detail/atrasan/mobile/04.webp';
import AtrasanMobile05 from './images/detail/atrasan/mobile/05.webp';

// ----drdp----
import DrdpBanner from './images/detail/drdp/banner-bg.webp';
import DrdpLogo from './images/detail/drdp/banner-logo.webp';

import DrdpMockup from '@/assets/images/phone-backgrounds/thumb-drdp.webp';
import DrdpVideo from '@/assets/videos/phone-videos/phone-drdp.mp4';

import DrdpPc01 from './images/detail/drdp/pc/01.webp';
import DrdpPc02 from './images/detail/drdp/pc/02.webp';
import DrdpPc03 from './images/detail/drdp/pc/03.webp';
import DrdpPc04 from './images/detail/drdp/pc/04.webp';

import DrdpTablet01 from './images/detail/drdp/tablet/01.webp';
import DrdpTablet02 from './images/detail/drdp/tablet/02.webp';
import DrdpTablet03 from './images/detail/drdp/tablet/03.webp';
import DrdpTablet04 from './images/detail/drdp/tablet/04.webp';
import DrdpTablet05 from './images/detail/drdp/tablet/05.webp';

import DrdpMobile01 from './images/detail/drdp/mobile/01.webp';
import DrdpMobile02 from './images/detail/drdp/mobile/02.webp';
import DrdpMobile03 from './images/detail/drdp/mobile/03.webp';
import DrdpMobile04 from './images/detail/drdp/mobile/04.webp';
import DrdpMobile05 from './images/detail/drdp/mobile/05.webp';

// ----nolto----
import NoltoBanner from './images/detail/nolto/banner-bg.webp';
import NoltoLogo from './images/detail/nolto/banner-logo.webp';

import NoltoMockup from '@/assets/images/phone-backgrounds/thumb-nolto.webp';
import NoltoVideo from '@/assets/videos/phone-videos/phone-nolto.mp4';

import NoltoPc01 from './images/detail/nolto/pc/01.webp';
import NoltoPc02 from './images/detail/nolto/pc/02.webp';
import NoltoPc03 from './images/detail/nolto/pc/03.webp';
import NoltoPc04 from './images/detail/nolto/pc/04.webp';

import NoltoTablet01 from './images/detail/nolto/tablet/01.webp';
import NoltoTablet02 from './images/detail/nolto/tablet/02.webp';
import NoltoTablet03 from './images/detail/nolto/tablet/03.webp';
import NoltoTablet04 from './images/detail/nolto/tablet/04.webp';

import NoltoMobile01 from './images/detail/nolto/mobile/01.webp';
import NoltoMobile02 from './images/detail/nolto/mobile/02.webp';
import NoltoMobile03 from './images/detail/nolto/mobile/03.webp';
import NoltoMobile04 from './images/detail/nolto/mobile/04.webp';

// 하트쉐어
import HeartShareBanner from './images/detail/heart-share/banner-bg.webp';
import HeartShareLogo from './images/detail/heart-share/banner-logo.webp';

import HeartShareMockup from '@/assets/images/phone-backgrounds/thumb-heart-share.webp';
import HeartShareVideo from '@/assets/videos/phone-videos/phone-heart-share.mp4';

import HeartSharePc01 from './images/detail/heart-share/pc/01.webp';
import HeartSharePc02 from './images/detail/heart-share/pc/02.webp';
import HeartSharePc03 from './images/detail/heart-share/pc/03.webp';
import HeartSharePc04 from './images/detail/heart-share/pc/04.webp';

import HeartShareTablet01 from './images/detail/heart-share/tablet/01.webp';
import HeartShareTablet02 from './images/detail/heart-share/tablet/02.webp';
import HeartShareTablet03 from './images/detail/heart-share/tablet/03.webp';
import HeartShareTablet04 from './images/detail/heart-share/tablet/04.webp';

import HeartShareMobile01 from './images/detail/heart-share/mobile/01.webp';
import HeartShareMobile02 from './images/detail/heart-share/mobile/02.webp';
import HeartShareMobile03 from './images/detail/heart-share/mobile/03.webp';
import HeartShareMobile04 from './images/detail/heart-share/mobile/04.webp';

// kingsland
import KingslandBanner from './images/detail/kingsland/banner-bg.webp';
import KingslandLogo from './images/detail/kingsland/banner-logo.webp';

import KingslandMockup from '@/assets/images/phone-backgrounds/thumb-kingsland.webp';
import KingslandVideo from '@/assets/videos/phone-videos/phone-kingsland.mp4';

import KingslandPc01 from '@/data/portfolio/images/detail/kingsland/pc/01.webp';
import KingslandPc02 from '@/data/portfolio/images/detail/kingsland/pc/02.webp';
import KingslandPc03 from '@/data/portfolio/images/detail/kingsland/pc/03.webp';
import KingslandPc04 from '@/data/portfolio/images/detail/kingsland/pc/04.webp';

import KingslandTablet01 from './images/detail/kingsland/tablet/01.webp';
import KingslandTablet02 from './images/detail/kingsland/tablet/02.webp';
import KingslandTablet03 from './images/detail/kingsland/tablet/03.webp';
import KingslandTablet04 from './images/detail/kingsland/tablet/04.webp';

import KingslandMobile01 from './images/detail/kingsland/mobile/01.webp';
import KingslandMobile02 from './images/detail/kingsland/mobile/02.webp';
import KingslandMobile03 from './images/detail/kingsland/mobile/03.webp';
import KingslandMobile04 from './images/detail/kingsland/mobile/04.webp';

// ocu
import OcuBanner from './images/detail/ocu/banner-bg.webp';
import OcuLogo from './images/detail/ocu/banner-logo.webp';

import OcuMockup from '@/assets/images/phone-backgrounds/thumb-ocu.webp';
import OcuVideo from '@/assets/videos/phone-videos/phone-ocu.mp4';

import OcuPc01 from './images/detail/ocu/pc/01.webp';
import OcuPc02 from './images/detail/ocu/pc/02.webp';
import OcuPc03 from './images/detail/ocu/pc/03.webp';
import OcuPc04 from './images/detail/ocu/pc/04.webp';
import OcuPc05 from './images/detail/ocu/pc/05.webp';

import OcuTablet01 from './images/detail/ocu/tablet/01.webp';
import OcuTablet02 from './images/detail/ocu/tablet/02.webp';
import OcuTablet03 from './images/detail/ocu/tablet/03.webp';
import OcuTablet04 from './images/detail/ocu/tablet/04.webp';
import OcuTablet05 from './images/detail/ocu/tablet/05.webp';

import OcuMobile01 from './images/detail/ocu/mobile/01.webp';
import OcuMobile02 from './images/detail/ocu/mobile/02.webp';
import OcuMobile03 from './images/detail/ocu/mobile/03.webp';
import OcuMobile04 from './images/detail/ocu/mobile/04.webp';
import OcuMobile05 from './images/detail/ocu/mobile/05.webp';

// 반려시대
import PetEraBanner from './images/detail/pet-era/banner-bg.webp';
import PetEraLogo from './images/detail/pet-era/banner-logo.webp';

import PetEraMockup from '@/assets/images/phone-backgrounds/thumb-pet-era.webp';
import PetEraVideo from '@/assets/videos/phone-videos/phone-pet-era.mp4';

import PetEraPc01 from './images/detail/pet-era/pc/01.webp';
import PetEraPc02 from './images/detail/pet-era/pc/02.webp';
import PetEraPc03 from './images/detail/pet-era/pc/03.webp';
import PetEraPc04 from './images/detail/pet-era/pc/04.webp';
import PetEraPc05 from './images/detail/pet-era/pc/05.webp';

import PetEraTablet01 from './images/detail/pet-era/tablet/01.webp';
import PetEraTablet02 from './images/detail/pet-era/tablet/02.webp';
import PetEraTablet03 from './images/detail/pet-era/tablet/03.webp';
import PetEraTablet04 from './images/detail/pet-era/tablet/04.webp';
import PetEraTablet05 from './images/detail/pet-era/tablet/05.webp';

import PetEraMobile01 from './images/detail/pet-era/mobile/01.webp';
import PetEraMobile02 from './images/detail/pet-era/mobile/02.webp';
import PetEraMobile03 from './images/detail/pet-era/mobile/03.webp';
import PetEraMobile04 from './images/detail/pet-era/mobile/04.webp';
import PetEraMobile05 from './images/detail/pet-era/mobile/05.webp';

// 링스쿨
import RingSchoolBanner from './images/detail/ring-school/banner-bg.webp';
import RingSchoolLogo from './images/detail/ring-school/banner-logo.webp';

// 목업없음

import RingSchoolPc01 from './images/detail/ring-school/pc/01.webp';
import RingSchoolPc02 from './images/detail/ring-school/pc/02.webp';
import RingSchoolPc03 from './images/detail/ring-school/pc/03.webp';
import RingSchoolPc04 from './images/detail/ring-school/pc/04.webp';

import RingSchoolTablet01 from './images/detail/ring-school/tablet/01.webp';
import RingSchoolTablet02 from './images/detail/ring-school/tablet/02.webp';
import RingSchoolTablet03 from './images/detail/ring-school/tablet/03.webp';
import RingSchoolTablet04 from './images/detail/ring-school/tablet/04.webp';

import RingSchoolMobile01 from './images/detail/ring-school/mobile/01.webp';
import RingSchoolMobile02 from './images/detail/ring-school/mobile/02.webp';
import RingSchoolMobile03 from './images/detail/ring-school/mobile/03.webp';
import RingSchoolMobile04 from './images/detail/ring-school/mobile/04.webp';

// 운세나우
import UnsaeNowBanner from './images/detail/unsae-now/banner-bg.webp';
import UnsaeNowLogo from './images/detail/unsae-now/banner-logo.webp';

import UnsaeNowMockup from '@/assets/images/phone-backgrounds/thumb-unsae-now.webp';
import UnsaeNowVideo from '@/assets/videos/phone-videos/phone-unsae-now.mp4';

import UnsaeNowPc01 from './images/detail/unsae-now/pc/01.webp';
import UnsaeNowPc02 from './images/detail/unsae-now/pc/02.webp';
import UnsaeNowPc03 from './images/detail/unsae-now/pc/03.webp';

import UnsaeNowTablet01 from './images/detail/unsae-now/tablet/01.webp';
import UnsaeNowTablet02 from './images/detail/unsae-now/tablet/02.webp';
import UnsaeNowTablet03 from './images/detail/unsae-now/tablet/03.webp';

import UnsaeNowMobile01 from './images/detail/unsae-now/mobile/01.webp';
import UnsaeNowMobile02 from './images/detail/unsae-now/mobile/02.webp';
import UnsaeNowMobile03 from './images/detail/unsae-now/mobile/03.webp';

// 폰의민족
import PhonePeopleBanner from './images/detail/phone-people/banner-bg.webp';
import PhonePeopleLogo from './images/detail/phone-people/banner-logo.webp';

import PhonePeopleMockup from '@/assets/images/phone-backgrounds/thumb-phone-people.webp';
import PhonePeopleVideo from '@/assets/videos/phone-videos/phone-phone-people.mp4';

import PhonePeoplePc01 from './images/detail/phone-people/pc/01.webp';
import PhonePeoplePc02 from './images/detail/phone-people/pc/02.webp';
import PhonePeoplePc03 from './images/detail/phone-people/pc/03.webp';
import PhonePeoplePc04 from './images/detail/phone-people/pc/04.webp';
import PhonePeoplePc05 from './images/detail/phone-people/pc/05.webp';

import PhonePeopleTablet01 from './images/detail/phone-people/tablet/01.webp';
import PhonePeopleTablet02 from './images/detail/phone-people/tablet/02.webp';
import PhonePeopleTablet03 from './images/detail/phone-people/tablet/03.webp';
import PhonePeopleTablet04 from './images/detail/phone-people/tablet/04.webp';

import PhonePeopleMobile01 from './images/detail/phone-people/mobile/01.webp';
import PhonePeopleMobile02 from './images/detail/phone-people/mobile/02.webp';
import PhonePeopleMobile03 from './images/detail/phone-people/mobile/03.webp';
import PhonePeopleMobile04 from './images/detail/phone-people/mobile/04.webp';
import PhonePeopleMobile05 from './images/detail/phone-people/mobile/05.webp';

// // @ts-ignore  //필요시 주석 해제
export const DETAIL_DATA: Record<PortfolioName, PortfolioDetailData> = {
	[PORTFOLIO_NAME.HYUNDAI]: {
		banner: {
			backgroundImage: HyundaiBanner,
			logoImage: HyundaiLogo,
			logoSize: {
				pc: { width: 857, height: 243 },
				tablet: { width: 457, height: 129 },
				mobile: { width: 228, height: 64 }
			}
		},
		mockup: {
			mockupImage: HyundaiMockup,
			mockupVideo: HyundaiVideo
		},
		projectInfo: {
			title: 'The Voice of HMG Leadership',
			description:
				'The Voice of HMG Leadership은 현대자동차그룹 정의선 회장의 메시지를 비롯해 그룹 주요 CEO 및 사장단의 비전과 철학을 임직원들이 쉽고 편리하게 접할 수 있도록 지원하는 디지털 플랫폼입니다. \n단순한 콘텐츠 제공을 넘어, 그룹의 미래지향적 가치와 경영 철학을 반영한 구조와 디자인으로 구성되어 있으며, 다국어 기능과 트랜스크립트 기능을 통해 다양한 언어권 사용자도 접근이 가능합니다.',
			clientName: '현대 오토에버',
			duration: '2024.04 ~ 2024.08',
			scope: '프론트엔드'
		},
		font: PORTFOLIO_FONT.HYUNDAI,
		color: {
			point: { hex: '#101016', textColor: 'white' },
			sub1: { hex: '#00AAD2', textColor: 'white' },
			sub2: { hex: '#DB564F', textColor: 'white' },
			sub3: { hex: '#BEC0C1', textColor: 'white' },
			sub4: { hex: '#ffffff', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				HyundaiPc01,
				HyundaiPc02,
				HyundaiPc03,
				HyundaiPc04,
				HyundaiPc05,
				HyundaiPc06
			],
			tablet: [
				HyundaiTablet01,
				HyundaiTablet02,
				HyundaiTablet03,
				HyundaiTablet04,
				HyundaiTablet05,
				HyundaiTablet06
			],
			mobile: [
				HyundaiMobile01,
				HyundaiMobile02,
				HyundaiMobile03,
				HyundaiMobile04,
				HyundaiMobile05,
				HyundaiMobile06
			]
		}
	},
	[PORTFOLIO_NAME.PARADISE_BUSAN]: {
		banner: {
			backgroundImage: ParadiseBusanBanner,
			logoImage: ParadiseBusanLogo,
			logoSize: {
				pc: { width: 312, height: 202 },
				tablet: { width: 250, height: 162 },
				mobile: { width: 125, height: 79 }
			}
		},
		mockup: {
			mockupImage: ParadiseBusanMockup,
			mockupVideo: ParadiseBusanVideo
		},
		projectInfo: {
			title: '스마트한 호텔 라이프',
			description:
				'파라다이스호텔 부산 앱은 고객에게 더욱 빠르고 편리한 비대면 투숙 경험을 제공합니다. \n모바일 체크인과 체크아웃 기능을 통해 프론트 데스크를 거치지 않고, 주차장에서 바로 객실로 이동할 수 있습니다.\n모바일 키, 예약 조회, 멤버십 관리 등 다양한 기능을 제공하고 있어, 투숙 전부터 퇴실까지 모든 과정이 간편하고 매끄럽게 이루어집니다.\n파라다이스호텔 부산 앱으로 스마트한 호텔 라이프를 경험해보세요.',
			clientName: '파라다이스 호텔 부산',
			duration: ' 2022.01 ~ 2025.06',
			scope: '1차, 2차, 3차 턴키개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#9C836A', textColor: 'white' },
			sub1: { hex: '#4D4843', textColor: 'white' },
			sub2: { hex: '#9B8C6E', textColor: 'white' },
			sub3: { hex: '#857B71', textColor: 'white' },
			sub4: { hex: '#F3F0E6', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				ParadiseBusanPc01,
				ParadiseBusanPc02,
				ParadiseBusanPc03,
				ParadiseBusanPc04,
				ParadiseBusanPc05
			],
			tablet: [
				ParadiseBusanTablet01,
				ParadiseBusanTablet02,
				ParadiseBusanTablet03,
				ParadiseBusanTablet04,
				ParadiseBusanTablet05
			],
			mobile: [
				ParadiseBusanMobile01,
				ParadiseBusanMobile02,
				ParadiseBusanMobile03,
				ParadiseBusanMobile04,
				ParadiseBusanMobile05
			]
		}
	},
	[PORTFOLIO_NAME.PARADISE_INCHEON]: {
		banner: {
			backgroundImage: ParadiseIncheonBanner,
			logoImage: ParadiseIncheonLogo,
			logoSize: {
				pc: { width: 960, height: 124 },
				tablet: { width: 480, height: 62 },
				mobile: { width: 192, height: 24 }
			}
		},
		mockup: {
			mockupImage: ParadiseIncheonMockup,
			mockupVideo: ParadiseIncheonVideo
		},
		projectInfo: {
			title: '파라다이스: 호텔, 아트, 엔터테인먼트',
			description:
				'파라다이스 호텔 및 카지노 고객을 위한 프리미엄 라이프스타일 통합 앱입니다. 객실 예약부터 모바일 체크인, 룸 키 서비스, 멤버십 혜택 확인까지 모든 과정을 앱 하나로 간편하게 제공합니다. 호텔뿐 아니라 아트 전시, 공연 등 다양한 엔터테인먼트 정보도 함께 제공하여 고객에게 더 나은 파라다이스시티 이용 경험을 제공합니다.',
			clientName: '파라다이스 호텔 인천',
			duration: '2022.01 ~ 2024.05',
			scope: '백엔드 개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#9C836A', textColor: 'white' },
			sub1: { hex: '#4D4843', textColor: 'white' },
			sub2: { hex: '#9B8C6E', textColor: 'white' },
			sub3: { hex: '#857B71', textColor: 'white' },
			sub4: { hex: '#F3F0E6', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				ParadiseIncheonPc01,
				ParadiseIncheonPc02,
				ParadiseIncheonPc03,
				ParadiseIncheonPc04
			],
			tablet: [
				ParadiseIncheonTablet01,
				ParadiseIncheonTablet02,
				ParadiseIncheonTablet03
			],
			mobile: [
				ParadiseIncheonMobile01,
				ParadiseIncheonMobile02,
				ParadiseIncheonMobile03
			]
		}
	},
	[PORTFOLIO_NAME.TTOKTTOK365]: {
		banner: {
			backgroundImage: 똑똑365Banner,
			logoImage: 똑똑365Logo,
			logoSize: {
				pc: { width: 412, height: 152 },
				tablet: { width: 260, height: 97 },
				mobile: { width: 135, height: 50 }
			}
		},
		mockup: {
			mockupImage: 똑똑365Mockup,
			mockupVideo: 똑똑365Video
		},
		projectInfo: {
			title: '똑똑365: 토탈 홈케어 플랫폼',
			description:
				'똑똑365는 집 청소부터 정리수납까지, 생활공간의 전반적인 관리 서비스를 제공하는 토탈 홈케어 플랫폼입니다. \n사용자는 자신이 중요하게 생각하는 청소 포인트나 생활 패턴에 맞춰 맞춤형 서비스를 신청할 수 있습니다. 단순한 매칭을 넘어, 욕실 하수구 청소, 가구 밑 먼지 제거, 러그 청소 등 사용자별 니즈에 맞춰 최적의 인력을 배정하고 있습니다.',
			clientName: '교육과이음',
			duration: '2024.08 ~ 2025.03',
			scope: '기획 일부, 백엔드, 프론트엔드'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#FE6F0F', textColor: 'white' },
			sub1: { hex: '#FFF7ED', textColor: '#111111' },
			sub2: { hex: '#F1EFEE', textColor: '#111111' },
			sub3: { hex: '#111827', textColor: 'white' },
			sub4: { hex: '#FFFFFF', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				똑똑365Pc01,
				똑똑365Pc02,
				똑똑365Pc03,
				똑똑365Pc04,
				똑똑365Pc05,
				똑똑365Pc06
			],
			tablet: [
				똑똑365Tablet01,
				똑똑365Tablet02,
				똑똑365Tablet03,
				똑똑365Tablet04,
				똑똑365Tablet05
			],
			mobile: [
				똑똑365Mobile01,
				똑똑365Mobile02,
				똑똑365Mobile03,
				똑똑365Mobile04,
				똑똑365Mobile05
			]
		}
	},
	[PORTFOLIO_NAME.DEAR_MONDAY]: {
		banner: {
			backgroundImage: DearMondayBanner,
			logoImage: DearMondayLogo,
			logoSize: {
				pc: { width: 546, height: 280 },
				tablet: { width: 328, height: 168 },
				mobile: { width: 197, height: 98 }
			}
		},
		mockup: {
			mockupImage: DearMondayMockup,
			mockupVideo: DearMondayVideo
		},
		projectInfo: {
			title: 'Dear Monday: \n새로운 워케이션의 시작',
			description:
				'Dear Monday는 아름다운 뷰로 리프레시 할 수 있는 장소에 창의력과 몰입을 극대화하는 공간을 큐레이션 합니다.\n 최적의 업무 환경을 갖춘 숙소와 코워킹 스페이스에서 워케이션을 즐기며 업무 생산성을 극대화하세요. \n다양한 지역에서 제공되는 프리미엄 워케이션 공간을 통해, 일과 휴식을 조화롭게 결합한 새로운 방식의 라이프스타일을 경험할 수 있습니다. \n단순한 원격 근무를 넘어, 지역 문화 체험, 웰니스 프로그램, 리프레시 활동 등을 결합하여 일과 삶의 균형을 찾을 수 있습니다. \n웹을 통해 간편하게 예약하고, 나만의 맞춤형 워케이션 플랜을 세워보세요.',
			clientName: '똑똑365',
			duration: '2023.07 ~ 2025.04',
			scope: '1차,2차 턴키개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#006868', textColor: 'white' },
			sub1: { hex: '#50AFAF', textColor: 'white' },
			sub2: { hex: '#19D2BC', textColor: 'white' },
			sub3: { hex: '#E9B300', textColor: 'white' },
			sub4: { hex: '#EDD481', textColor: 'white' }
		},
		contentImages: {
			pc: [
				DearMondayPc01,
				DearMondayPc02,
				DearMondayPc03,
				DearMondayPc04,
				DearMondayPc05,
				DearMondayPc06
			],
			tablet: [
				DearMondayTablet01,
				DearMondayTablet02,
				DearMondayTablet03,
				DearMondayTablet04,
				DearMondayTablet05,
				DearMondayTablet06
			],
			mobile: [
				DearMondayMobile01,
				DearMondayMobile02,
				DearMondayMobile03,
				DearMondayMobile04,
				DearMondayMobile05,
				DearMondayMobile06
			]
		}
	},
	[PORTFOLIO_NAME.VROONG]: {
		banner: {
			backgroundImage: VroongBanner,
			logoImage: VroongLogo,
			logoSize: {
				pc: { width: 501, height: 81 },
				tablet: { width: 483, height: 79 },
				mobile: { width: 193, height: 31 }
			}
		},
		mockup: {
			mockupImage: VroongMockup,
			mockupVideo: VroongVideo
		},
		projectInfo: {
			title: '부릉: 프리미엄 배달 서비스',
			description: `부릉은 자체 개발한 물류 첨단 기술과 물류 인프라를 바탕으로 고객의 유통 물류를 통합하고 디지털화하는 서비스 브랜드입니다. 
중앙화된 직영 이륜 배송 네트워크를 통해 기업 고객을 위한 맞춤형 라스트 마일 서비스를 제공하며,
‘VROONG TMS Engine’이 탑재된 운송관리 시스템(TMS)으로 클라우드 환경에서 물류 프로세스 통합관제/관리가 가능합니다.
단순한 배달을 넘어, 물류의 혁신을 만들어가는 스마트 배송 플랫폼, 부릉과 함께하세요.`,
			clientName: '부릉',
			duration: '2021.04 ~ 2021.10',
			scope: '기획'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#05CE82', textColor: 'white' },
			sub1: { hex: '#F2FDF9', textColor: '#111111' },
			sub2: { hex: '#E6F9F3', textColor: '#111111' },
			sub3: { hex: '#F6F6F6', textColor: '#111111' },
			sub4: { hex: '#006764', textColor: 'white' }
		},
		contentImages: {
			pc: [
				VroongPc01,
				VroongPc02,
				VroongPc03,
				VroongPc04,
				VroongPc05,
				VroongPc06
			],
			tablet: [
				VroongTablet01,
				VroongTablet02,
				VroongTablet03,
				VroongTablet04,
				VroongTablet05,
				VroongTablet06
			],
			mobile: [
				VroongMobile01,
				VroongMobile02,
				VroongMobile03,
				VroongMobile04,
				VroongMobile05,
				VroongMobile06
			]
		}
	},
	[PORTFOLIO_NAME.ARTIKET]: {
		banner: {
			backgroundImage: ArtiketBanner,
			logoImage: ArtiketLogo,
			logoSize: {
				pc: { width: 360, height: 268 },
				tablet: { width: 228, height: 169 },
				mobile: { width: 144, height: 107 }
			}
		},
		mockup: {
			mockupImage: ArtiketMockup,
			mockupVideo: ArtiketVideo
		},
		projectInfo: {
			title: '예술가들을 위한 마켓플레이스',
			description: `아티켓은 다양한 예술가들이 자신의 작품을 소개하고 판매할 수 있는 창작 마켓플레이스입니다.
사용자들은 피드를 통해 작품을 감상하고, 마음에 드는 작품을 직접 구매할 수 있습니다. 사용자는 예술가에게 문의 메시지를
보내거나 구매한 작품의 리뷰를 작성하며 예술가와 소통할 수 있습니다.
예술가들은 자신의 프로필을 꾸미고 작품을 전시하며 사용자들의 피드백을 통해 더 나은 작품 활동을 이어갈 수 있습니다.`,
			clientName: '아티켓',
			duration: '2021.04 ~ 2021.10',
			scope: '프론트 개발'
		},
		font: PORTFOLIO_FONT.NOTOSANS,
		color: {
			point: { hex: '#8225F9', textColor: 'white' },
			sub1: { hex: '#FF3838', textColor: 'white' },
			sub2: { hex: '#DDDDDD', textColor: '#111111' },
			sub3: { hex: '#343434', textColor: 'white' },
			sub4: { hex: '#F4FDF5', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				ArtiketPc01,
				ArtiketPc02,
				ArtiketPc03,
				ArtiketPc04,
				ArtiketPc05,
				ArtiketPc06
			],
			tablet: [
				ArtiketTablet01,
				ArtiketTablet02,
				ArtiketTablet03,
				ArtiketTablet04,
				ArtiketTablet05,
				ArtiketTablet06
			],
			mobile: [
				ArtiketMobile01,
				ArtiketMobile02,
				ArtiketMobile03,
				ArtiketMobile04,
				ArtiketMobile05,
				ArtiketMobile06
			]
		}
	},
	[PORTFOLIO_NAME.ATRASAN]: {
		banner: {
			backgroundImage: AtrasanBanner,
			logoImage: AtrasanLogo,
			logoSize: {
				pc: { width: 876, height: 131 },
				tablet: { width: 616, height: 92 },
				mobile: { width: 226, height: 33 }
			},
			shaderOpacity: 0.1
		},
		mockup: {
			mockupImage: AtrasanMockup,
			mockupVideo: AtrasanVideo
		},
		projectInfo: {
			title: '전문적인 재회 컨설팅 서비스',
			description: `아트라상은 재회 상담 및 컨설팅 전문 서비스로, 15년간 축적된 노하우와 수만 건에 달하는 상담 경험을 바탕으로
	내담자에게 실질적인 솔루션을 제공합니다. 연인과 재회를 희망하거나, 관계 문제로 고민 중인 분들에게 맞춤형
	조언을 제공하며 체계적인 절차와 전문성 높은 상담을 통해 사용자의 관계 회복을 돕고 있습니다.
	아트라상은 단순한 상담을 넘어, 심리적 회복과 건강한 재회를 위한 동반자가 되어드립니다.`,
			clientName: '아트라상',
			duration: '2024.05 ~ 2024.10',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.NOTOSANS,
		color: {
			point: { hex: '#08A2BB', textColor: 'white' },
			sub1: { hex: '#097485', textColor: 'white' },
			sub2: { hex: '#FE6F0F', textColor: 'white' },
			sub3: { hex: '#F1F9FA', textColor: '#111111' },
			sub4: { hex: '#FFF6EF', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				AtrasanPc01,
				AtrasanPc02,
				AtrasanPc03,
				AtrasanPc04,
				AtrasanPc05
			],
			tablet: [
				AtrasanTablet01,
				AtrasanTablet02,
				AtrasanTablet03,
				AtrasanTablet04,
				AtrasanTablet05
			],
			mobile: [
				AtrasanMobile01,
				AtrasanMobile02,
				AtrasanMobile03,
				AtrasanMobile04,
				AtrasanMobile05
			]
		}
	},
	[PORTFOLIO_NAME.DRDP]: {
		banner: {
			backgroundImage: DrdpBanner,
			logoImage: DrdpLogo,
			logoSize: {
				pc: { width: 401, height: 327 },
				tablet: { width: 200, height: 163 },
				mobile: { width: 100, height: 81 }
			},
			shaderOpacity: 0.4
		},
		mockup: {
			mockupImage: DrdpMockup,
			mockupVideo: DrdpVideo
		},
		projectInfo: {
			title: '두피 건강 파트너, 닥터두피',
			description: `닥터두피는 두피와 모발 건강에 관심있는 사람들을 위한 스마트케어 앱입니다. 지역 기반 병원 정보부터, 전문가 Q&A,
AI 기반 두피/모발 분석까지 사용자에게 꼭 맞는 맞춤형 솔루션을 제공합니다. 사용자 주변 인기 병원 추천, 두피 관련 정보 콘텐츠,
키워드 검색 기능 등을 통해 쉽고 편리한 두피관리를 경험해보세요.`,
			clientName: '닥터두피',
			duration: '2022.01 ~ 2022.04',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.SUIT,
		color: {
			point: { hex: '#4285F4', textColor: 'white' },
			sub1: { hex: '#E7F0FF', textColor: '#111111' },
			sub2: { hex: '#A5BCF8', textColor: '#111111' },
			sub3: { hex: '#DEEBFF', textColor: '#111111' },
			sub4: { hex: '#FBB4B0', textColor: '#111111' }
		},
		contentImages: {
			pc: [DrdpPc01, DrdpPc02, DrdpPc03, DrdpPc04],
			tablet: [
				DrdpTablet01,
				DrdpTablet02,
				DrdpTablet03,
				DrdpTablet04,
				DrdpTablet05
			],
			mobile: [
				DrdpMobile01,
				DrdpMobile02,
				DrdpMobile03,
				DrdpMobile04,
				DrdpMobile05
			]
		}
	},
	[PORTFOLIO_NAME.NOLTO]: {
		banner: {
			backgroundImage: NoltoBanner,
			logoImage: NoltoLogo,
			logoSize: {
				pc: { width: 288, height: 288 },
				tablet: { width: 184, height: 184 },
				mobile: { width: 92, height: 92 }
			}
		},
		mockup: {
			mockupImage: NoltoMockup,
			mockupVideo: NoltoVideo
		},
		projectInfo: {
			title: '내 손안의 역사 가이드',
			description: `놀토 앱은 자녀의 학년에 맞는 역사 여행지와 체험 프로그램을 추천해주는 모바일 앱 서비스입니다.
전국 500개 이상의 문화유적지와 체험 장소 정보를 기반으로,  학년별, 시대별 맞춤 콘텐츠를 제공하여
자녀가 즐겁게 역사와 문화를 배울 수 있도록 돕습니다. 놀토 앱으로 유익한 역사 여행을 체험해보세요.`,
			clientName: '문화상상연구소',
			duration: '2024.07 ~ 2025. 01',
			scope: '프론트 개발'
		},
		font: PORTFOLIO_FONT.NOTOSANS,
		color: {
			point: { hex: '#4285F4', textColor: 'white' },
			sub1: { hex: '#758AA1', textColor: 'white' },
			sub2: { hex: '#F85A40', textColor: 'white' },
			sub3: { hex: '#FFC845', textColor: 'white' },
			sub4: { hex: '#30C39E', textColor: 'white' }
		},
		contentImages: {
			pc: [NoltoPc01, NoltoPc02, NoltoPc03, NoltoPc04],
			tablet: [
				NoltoTablet01,
				NoltoTablet02,
				NoltoTablet03,
				NoltoTablet04
			],
			mobile: [NoltoMobile01, NoltoMobile02, NoltoMobile03, NoltoMobile04]
		}
	},
	[PORTFOLIO_NAME.PET_ERA]: {
		banner: {
			backgroundImage: PetEraBanner,
			logoImage: PetEraLogo,
			logoSize: {
				pc: { width: 515, height: 155 },
				tablet: { width: 290, height: 87 },
				mobile: { width: 121, height: 36 }
			}
		},
		mockup: {
			mockupImage: PetEraMockup,
			mockupVideo: PetEraVideo
		},
		projectInfo: {
			title: '반려견 유치원 CRM 서비스',
			description: `반려시대는 반려견 유치원을 쉽고 빠르게 찾고 예약할 수 있는 반려견 유치원 CRM 서비스입니다. 1,000만 반려인
시대에 발맞춰, 지역별, 유형별 유치원을 한눈에 비교하고 실제 후기와 사진을 통해 신뢰도 높은 선택이 가능하도록 도와줍니다.
등록된 유치원에서는 반려견의 상태를 실시간으로 관리하고 보호자와 공유할 수 있어, 떨어져도 안심하고 맡길 수 있습니다.
반려견과 보호자 모두를 위한 새로운 유치원 경험, 반려시대에서 시작해보세요.`,
			clientName: '퍼니디어',
			duration: '2021.10 ~ 2022.07',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#FAE100', textColor: '#111111' },
			sub1: { hex: '#383838', textColor: 'white' },
			sub2: { hex: '#FFFCE4', textColor: '#111111' },
			sub3: { hex: '#F4F4F4', textColor: '#111111' },
			sub4: { hex: '#17A9FB', textColor: 'white' }
		},
		contentImages: {
			pc: [PetEraPc01, PetEraPc02, PetEraPc03, PetEraPc04, PetEraPc05],
			tablet: [
				PetEraTablet01,
				PetEraTablet02,
				PetEraTablet03,
				PetEraTablet04,
				PetEraTablet05
			],
			mobile: [
				PetEraMobile01,
				PetEraMobile02,
				PetEraMobile03,
				PetEraMobile04,
				PetEraMobile05
			]
		}
	},
	[PORTFOLIO_NAME.OCU]: {
		banner: {
			backgroundImage: OcuBanner,
			logoImage: OcuLogo,
			logoSize: {
				pc: { width: 438, height: 214 },
				tablet: { width: 280, height: 137 },
				mobile: { width: 140, height: 69 }
			}
		},
		mockup: {
			mockupImage: OcuMockup,
			mockupVideo: OcuVideo
		},
		projectInfo: {
			title: '재학생을 위한 학습 파트너',
			description: `OCU는 한국열린사이버대학교 학생들이 과제를 놓치지 않고, 강의를 효율적으로 수강하며, 학습 성과를 체계적으로 관리할 수 있도록
도와주는 학습 파트너입니다. 학생들의 전공과 학년 정보를 기반으로 맞춤형 강의 및 과제 일정을 제공합니다. 실시간 강의 정보,
강의 평가, 강의 이어보기, 공부시간 측정 등 다양한 기능을 통해 사이버대학 특유의 자기주도 학습을 효과적으로 지원합니다.`,
			clientName: '한국 열린사이버 대학교',
			duration: '2022.07 ~ 2022.10',
			scope: '프론트 개발, 백엔드 개발'
		},
		font: PORTFOLIO_FONT.SUIT,
		color: {
			point: { hex: '#124480', textColor: 'white' },
			sub1: { hex: '#FCCB4D', textColor: 'white' },
			sub2: { hex: '#E4F1FF', textColor: '#111111' },
			sub3: { hex: '#FFF7E1', textColor: '#111111' },
			sub4: { hex: '#D9D9D9', textColor: '#111111' }
		},
		contentImages: {
			pc: [OcuPc01, OcuPc02, OcuPc03, OcuPc04, OcuPc05],
			tablet: [
				OcuTablet01,
				OcuTablet02,
				OcuTablet03,
				OcuTablet04,
				OcuTablet05
			],
			mobile: [
				OcuMobile01,
				OcuMobile02,
				OcuMobile03,
				OcuMobile04,
				OcuMobile05
			]
		}
	},
	[PORTFOLIO_NAME.KINGSLAND]: {
		banner: {
			backgroundImage: KingslandBanner,
			logoImage: KingslandLogo,
			logoSize: {
				pc: { width: 635, height: 150 },
				tablet: { width: 434, height: 100 },
				mobile: { width: 173, height: 35 }
			}
		},
		mockup: {
			mockupImage: KingslandMockup,
			mockupVideo: KingslandVideo
		},
		projectInfo: {
			title: '토지 거래 전문 컨설팅',
			description: `킹스랜드는 부동산 거래의 효율성과 전문성을 높이기 위한 컨설턴트 솔루션 서비스입니다. 복잡한 토지 정보를
손쉽게 파악할 수 있도록 도와주는 마스터 추천 기능과 맞춤형 토지 분석, 컨설팅까지 원스톱으로 제공하는 전문 서비스를
갖추고 있습니다. 지역별 상세 정보와 실시간 거래 현황, 전문가가 추천하는 토지 리스트 등을 제공해 부동산 초보자부터
전문가까지 모두가 만족할 수 있는 정보와 기능을 제공합니다.`,
			clientName: '골텍',
			duration: '2022.08 ~ 2023.01',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.SUIT,
		color: {
			point: { hex: '#7AC061', textColor: 'white' },
			sub1: { hex: '#9BCF9D', textColor: 'white' },
			sub2: { hex: '#93E6A3', textColor: 'white' },
			sub3: { hex: '#54AAA8', textColor: 'white' },
			sub4: { hex: '#4C9593', textColor: 'white' }
		},
		contentImages: {
			pc: [KingslandPc01, KingslandPc02, KingslandPc03, KingslandPc04],
			tablet: [
				KingslandTablet01,
				KingslandTablet02,
				KingslandTablet03,
				KingslandTablet04
			],
			mobile: [
				KingslandMobile01,
				KingslandMobile02,
				KingslandMobile03,
				KingslandMobile04
			]
		}
	},
	[PORTFOLIO_NAME.RING_SCHOOL]: {
		banner: {
			backgroundImage: RingSchoolBanner,
			logoImage: RingSchoolLogo,
			logoSize: {
				pc: { width: 569, height: 173 },
				tablet: { width: 355, height: 108 },
				mobile: { width: 152, height: 46 }
			}
		},
		// 목업없음
		projectInfo: {
			title: 'LG헬로비전 디지털 교육 플랫폼',
			description: `LG헬로비전의 교육공간혁신 플랫폼 링스쿨은 교실 내 디지털 기기와 학습 환경을 하나의 플랫폼에서 통합 제어할
	수 있는 디지털 교육 플랫폼입니다. 교사와 학생이 직관적인 UI/UX 환경에서 기기 간 연결, 자료 공유, 수업 모니터링 등을
	손쉽게 실행할 수 있으며, 교실 환경 제어 및 유지보수까지 원스톱으로 지원합니다. 학습자 중심의 수업 운영과 맞춤형 학습
	지원을 통해 디지털 기반 교육의 효율성과 몰입도를 높여줍니다. 링스쿨은 교실을 넘어 미래형 학습 공간을 구현합니다. `,
			clientName: 'LG 헬로비전',
			duration: '2023.11 ~ 2025.02',
			scope: '프론트 개발'
		},
		font: PORTFOLIO_FONT.NOTOSANS,
		color: {
			point: { hex: '#4285F4', textColor: 'white' },
			sub1: { hex: '#758AA1', textColor: 'white' },
			sub2: { hex: '##F85A40', textColor: 'white' },
			sub3: { hex: '#FFC845', textColor: 'white' },
			sub4: { hex: '#30C39E', textColor: 'white' }
		},
		contentImages: {
			pc: [
				RingSchoolPc01,
				RingSchoolPc02,
				RingSchoolPc03,
				RingSchoolPc04
			],
			tablet: [
				RingSchoolTablet01,
				RingSchoolTablet02,
				RingSchoolTablet03,
				RingSchoolTablet04
			],
			mobile: [
				RingSchoolMobile01,
				RingSchoolMobile02,
				RingSchoolMobile03,
				RingSchoolMobile04
			]
		}
	},
	[PORTFOLIO_NAME.UNSAE_NOW]: {
		banner: {
			backgroundImage: UnsaeNowBanner,
			logoImage: UnsaeNowLogo,
			logoSize: {
				pc: { width: 703, height: 238 },
				tablet: { width: 450, height: 152 },
				mobile: { width: 225, height: 76 }
			}
		},
		mockup: {
			mockupImage: UnsaeNowMockup,
			mockupVideo: UnsaeNowVideo
		},
		projectInfo: {
			title: '비대면 운세 플랫폼',
			description: `운세나우는 타로, 토정비결, 궁합, 정통사주 등 다양한 운세 콘텐츠를 기반으로 한 운세 상담 화상 서비스입니다.
사용자는 비대면 환경에서도 검증된 상담 전문가들과 화상 통화를 통해 쉽고 빠르게 상담을 받을 수 있으며,
심리 상담 및 신점 상담도 함께 제공되어 맞춤형 조언을 받을 수 있습니다. 간편한 로그인과 직관적인 UI/UX로
상담을 예약하고 진행할 수 있으며, 실시간 인기 상담사 추천, 리뷰 기반 선택 기능, 멤버십 혜택 등 차별화된 기능으로
신뢰도와 접근성을 높였습니다.`,
			clientName: '팔자의나라',
			duration: '2021.10 ~ 2022.05',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.NOTOSANS,
		color: {
			point: { hex: '#FFD438', textColor: '#111111' },
			sub1: { hex: '#FFF1C0', textColor: '#111111' },
			sub2: { hex: '#FFFAE8', textColor: '#111111' },
			sub3: { hex: '#5F3B27', textColor: 'white' },
			sub4: { hex: '#A7785D', textColor: 'white' }
		},
		contentImages: {
			pc: [UnsaeNowPc01, UnsaeNowPc02, UnsaeNowPc03],
			tablet: [UnsaeNowTablet01, UnsaeNowTablet02, UnsaeNowTablet03],
			mobile: [UnsaeNowMobile01, UnsaeNowMobile02, UnsaeNowMobile03]
		}
	},
	[PORTFOLIO_NAME.HEART_SHARE]: {
		banner: {
			backgroundImage: HeartShareBanner,
			logoImage: HeartShareLogo,
			logoSize: {
				pc: { width: 452, height: 195 },
				tablet: { width: 303, height: 122 },
				mobile: { width: 142, height: 61 }
			}
		},
		mockup: {
			mockupImage: HeartShareMockup,
			mockupVideo: HeartShareVideo
		},
		projectInfo: {
			title: '세상을 바꾸는 곳',
			description: `하트쉐어는 앱 포인트를 활용해 누구나 쉽게 기부에 참여할 수 있는 모바일 기부 플랫폼입니다.
일상 속에서 적립된 포인트를 모아 손쉽게 기부할 수 있으며, 기부금의 사용 내역을 투명하게 공개하여 신뢰를
더합니다. 하트쉐어는 기부 대상자의 감사 인사를 공유하고, 사회적 가치를 실현할 수 있는 따뜻한 경험을
제공합니다. 기부 문화를 일상에 스며들게 하며, 사용자 누구나 손쉽게 착한 소비를 실천할 수 있는 환경을 만들어 갑니다.`,
			clientName: '트라이번',
			duration: '2022.10 ~ 2023.05',
			scope: '턴키 개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#FB881E', textColor: 'white' },
			sub1: { hex: '#0E578C', textColor: 'white' },
			sub2: { hex: '#1270B4', textColor: 'white' },
			sub3: { hex: '#EFF8FF', textColor: '#111111' },
			sub4: { hex: '#F9F9F9', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				HeartSharePc01,
				HeartSharePc02,
				HeartSharePc03,
				HeartSharePc04
			],
			tablet: [
				HeartShareTablet01,
				HeartShareTablet02,
				HeartShareTablet03,
				HeartShareTablet04
			],
			mobile: [
				HeartShareMobile01,
				HeartShareMobile02,
				HeartShareMobile03,
				HeartShareMobile04
			]
		}
	},
	[PORTFOLIO_NAME.PHONE_PEOPLE]: {
		banner: {
			backgroundImage: PhonePeopleBanner,
			logoImage: PhonePeopleLogo,
			logoSize: {
				pc: { width: 310, height: 281 },
				tablet: { width: 223, height: 202 },
				mobile: { width: 114, height: 103 }
			}
		},
		mockup: {
			mockupImage: PhonePeopleMockup,
			mockupVideo: PhonePeopleVideo
		},
		projectInfo: {
			title: '폰의 민족: 스마트한 중고폰 거래의 기준',
			description:
				'폰의 민족은 복잡하고 불투명했던 기존 중고폰 시장을 혁신하여, 누구나 믿고 거래할 수 있는 신뢰 기반의 중고폰 이커머스 플랫폼입니다. \n실시간 시장 데이터를 활용한 시스템을 통해 매입 가격의 투명성을 확보하였으며, 기기 상태 확인부터 대금 지급까지 전 과정을 원스톱으로 처리할 수 있는 직관적인 프로세스를 제공합니다. \n개인정보 보안을 위한 완벽한 데이터 삭제 솔루션과 신속한 정산 시스템을 결합하여 가장 안전하고 편리한 모바일 라이프를 지원합니다.',
			clientName: '폰의 민족',
			duration: 'xxxx.xx ~ xxxx.xx',
			scope: '브랜딩, 턴키 개발'
		},
		font: PORTFOLIO_FONT.PRETENDARD,
		color: {
			point: { hex: '#2C90D8', textColor: 'white' },
			sub1: { hex: '#F4F9FD', textColor: '#111111' },
			sub2: { hex: '#D5E9F6', textColor: '#111111' },
			sub3: { hex: '#15171C', textColor: 'white' },
			sub4: { hex: '#FFFFFF', textColor: '#111111' }
		},
		contentImages: {
			pc: [
				PhonePeoplePc01,
				PhonePeoplePc02,
				PhonePeoplePc03,
				PhonePeoplePc04,
				PhonePeoplePc05
			],
			tablet: [
				PhonePeopleTablet01,
				PhonePeopleTablet02,
				PhonePeopleTablet03,
				PhonePeopleTablet04
			],
			mobile: [
				PhonePeopleMobile01,
				PhonePeopleMobile02,
				PhonePeopleMobile03,
				PhonePeopleMobile04,
				PhonePeopleMobile05
			]
		}
	}
};
